import { render, staticRenderFns } from "./SupplierRefundList.vue?vue&type=template&id=5e10aab7&scoped=true&"
import script from "./SupplierRefundList.vue?vue&type=script&lang=js&"
export * from "./SupplierRefundList.vue?vue&type=script&lang=js&"
import style0 from "./SupplierRefundList.vue?vue&type=style&index=0&id=5e10aab7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e10aab7",
  null
  
)

export default component.exports